import { images } from "../../assets/Images/assetsImages";
import Carousel from "../SharedComponents/Carousel";
import ServiceCard from "./SharedComponents/ServiceCard";

const ServicesSection = () => {

    const servicesData = [
            { title: "Parties", image: images.CateringService1 },
            { title: "Gatherings", image: images.CateringService2 },
            { title: "Meetings", image: images.CateringService3 },
          ];

    return (
        <section className="w-full xs:h-[480px] h-screen md:h-full flex flex-col">
            <div className='w-full h-full flex flex-col justify-center items-center py-[80px] bg-[#F5E9D7]'>
                <div className="z-10 hidden w-full gap-0 mx-auto lg:grid lg:grid-cols-3"
                    style={{ maxWidth: 'calc(100% - 80px)' }}  
                    initial={{ y: "15%", opacity: 0 }}
                    whileInView={{ y: "0", opacity: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}>
                    {servicesData.map((service, index) => (
                        <div key={index} className='flex items-center justify-center'>
                            <ServiceCard
                                title={service.title}
                                image={service.image}
                            />
                        </div>
                    ))}
                </div>

                <div className="z-10 hidden w-full gap-0 mt-10 md:grid md:grid-cols-2 lg:hidden"  
                    initial={{ y: "15%", opacity: 0 }}
                    whileInView={{ y: "0", opacity: 1 }}
                    transition={{ duration: 1.5, ease: "easeOut" }}>
                    {servicesData.map((service, index) => (
                        <div key={index} className="flex items-center justify-center">
                            <ServiceCard
                                title={service.title}
                                image={service.image}
                            />
                        </div>
                    ))}
                </div>

                <div className="md:hidden">
                    <Carousel autoSlide={true} isProduct={true}>
                        {servicesData.map((service, index) => (
                            <ServiceCard
                                title={service.title}
                                image={service.image}
                            />
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    )
}

export default ServicesSection
